// src/router/index.js
import Vue from "vue";
import VueRouter from "vue-router";
import PersonalTerminal from "@/views/PersonalTerminal.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: () => import("@/views/Home.vue"), // 把现有的 App.vue 内容移到这里
  // },
  {
    path: "/personal-terminal",
    name: "PersonalTerminal",
    component: PersonalTerminal,
  },
  // 后续添加其他详情页
  {
    path: "/smart-wearable",
    name: "SmartWearable",
    component: () => import("@/views/SmartWearable.vue"),
  },
  {
    path: "/home-terminal",
    name: "HomeTerminal",
    component: () => import("@/views/HomeTerminal.vue"),
  },
  {
    path: "/smart-robot",
    name: "SmartRobot",
    component: () => import("@/views/SmartRobot.vue"),
  },
  {
    path: "/ai-software",
    name: "AISoftware",
    component: () => import("@/views/AISoftware.vue"),
  },
  {
    path: "/tech-service",
    name: "TechService",
    component: () => import("@/views/TechService.vue"),
  },
  {
    path: "/company-intro",
    name: "CompanyInfo",
    component: () => import("@/views/CompanyInfo.vue"),
  },
  {
    path: "/partners",
    name: "Partners",
    component: () => import("@/components/PartnersSection.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/components/AboutSection.vue"),
  },
  {
    path: "/advantages",
    name: "Advantages",
    component: () => import("@/components/AdvantagesSection.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/views/Contact.vue"),
  },
];

const router = new VueRouter({
  mode: "hash", // 使用 hash 模式，兼容性更好
  routes,
});

export default router;
